import { PropertyRepresentationCreateReq } from '@/types/property-representation'
import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

const endpoint = '/api/v1/property-representatives'

export function usePropertyRepresentativeCreate() {
  const { mutateAsync: onCreate, isPending } = useMutation({
    mutationKey: ['property-representative.create'],
    mutationFn: async (req: PropertyRepresentationCreateReq) => {
      await axios.post(`${endpoint}`, req)
    },
  })

  return { onCreate, isLoading: isPending }
}
